export default function Footer()
{
    return (
        <div className="footer">
            <span>&copy; 2025 Seow Sin Kiat - v3.00.06</span>
        </div>
    );
}